<tui-input
  formControlName="contact"
  [tuiTextfieldSize]="tuiElementLargeSize"
  [class.tui-skeleton]="loading"
  [class.tui-skeleton_text]="loading"
>
  <!-- Изменить -->
  <!-- {{ allowContactFieldEditing ? ('components.contacts.fields.contactValue' | translate) : contact.value.description }} -->
</tui-input>
